import { RcFile } from "antd/es/upload";

/**
 * Converts a file to base64 format
 * @param file The file to convert
 * @returns A promise that resolves to the base64 string
 */
export const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });